import { render } from "./UiAppbar.vue?vue&type=template&id=3f238e0f&ts=true"
import script from "./UiAppbar.vue?vue&type=script&lang=ts"
export * from "./UiAppbar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__